import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { API_BASE_URL } from '../lib/api';
import { joinOneLiner } from '../lib/fleet';
import { OnboardingCopyButton } from './OnboardingCopyButton';

// "RUN ON YOUR SERVER" — the box step's raised mono panel (canvas ONBOARDING
// artboard). Presenter.
//
// The command is the SHIPPED one (`joinOneLiner`, 06b), never the canvas's
// `--token dz_live_…` line: `read -rsp` prompts for the enrollment token, so it
// never rides argv, the URL query or the shell history. That also makes the
// command token-independent — it is the same on every box and needs no mint to
// show, which is why it leads the step instead of hiding behind one.
//
// A refused clipboard selects the command itself, so a manual copy still works.

const COMMAND_ID = 'onboarding-join-command';

export function OnboardingCommand(): JSX.Element {
  const command = (): string => joinOneLiner(API_BASE_URL);

  const select = (): void => {
    const node = document.getElementById(COMMAND_ID);
    const selection = window.getSelection();
    if (!node || !selection) return;
    const range = document.createRange();
    range.selectNodeContents(node);
    selection.removeAllRanges();
    selection.addRange(range);
  };

  return (
    <section class="onboarding-command" aria-labelledby="onboarding-command-label">
      <div class="onboarding-command__head">
        <h3 id="onboarding-command-label" class="onboarding-command__label">
          {t('onboarding.box_command_label')}
        </h3>
        <OnboardingCopyButton
          text={command}
          label={t('onboarding.box_command_copy')}
          copiedLabel={t('onboarding.copied')}
          refusedLabel={t('onboarding.copy_select')}
          onRefused={select}
        />
      </div>
      <pre class="onboarding-command__code">
        <code id={COMMAND_ID}>{command()}</code>
      </pre>
      <p class="onboarding-command__hint">{t('onboarding.box_command_hint')}</p>
    </section>
  );
}
